export const MASK_PATTERN = {
  cpf: "999.999.999-99",
  cnpj: "99.999.999/9999-99",
  cpfCnpj: ["999.999.999-99", "99.999.999/9999-99"],
  phone: "(99) 9999-9999",
  cellphone: "(99) 99999-9999",
  cep: "99999-999",
  date: "99/99/9999",
  card: "9999 9999 9999 9999",
  cardDate: "99/9999",
  number: "9999999"
};
